import { format, addMinutes, startOfDay } from 'date-fns';

const HOURS_PER_DAY = 24;
const DEFAULT_INTERVAL_IN_MINUTES = 5;

export const getTimes = (intl, intervalMinutes = DEFAULT_INTERVAL_IN_MINUTES) => {
  let runningDate = startOfDay(new Date());
  const maxIterations = (HOURS_PER_DAY * 60) / intervalMinutes;
  const times = [];

  for (let i = 0; i < maxIterations; i += 1) {
    const label = intl.formatDate(runningDate, { format: 'time' });
    const value = format(runningDate, 'HH:mm');
    times.push({
      label,
      value,
      match: label,
    });
    runningDate = addMinutes(runningDate, intervalMinutes);
  }
  return times;
};
